import {inject, Injectable} from '@angular/core';
import {TelegramService} from "./telegram.service";
import {MessageTelegram} from "../types/last-message.types";
import {MessagesQueryParams} from "../types/telegram-page.types";
import {TelegramAccountsService} from "./telegram-accounts.service";

type LoadInitialMessagesParams = {
  chatId?: number;
  accountId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TelegramMessagesService {
  private telegramService: TelegramService = inject(TelegramService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);

  public async loadInitialMessages({ chatId, accountId }: LoadInitialMessagesParams): Promise<Array<MessageTelegram>> {
    if (!chatId || !accountId) { return []; }

    const params = this.setMessagesQueryParams(chatId);
    const messages = await this.telegramService.getMessages(params).catch(() => []);

    return messages?.length ? this.sortMessages(messages) : messages;
  }

  public sortMessages(messages: Array<MessageTelegram>): Array<MessageTelegram> {
    return messages.sort((msgA, msgB) => {
      return msgA.date - msgB.date;
    });
  }

  public hasMessagesChanged(newMessages: Array<MessageTelegram>, oldMessages: Array<MessageTelegram>): boolean {
    if (!oldMessages || !newMessages) { return true; }

    if (newMessages.length !== oldMessages.length) { return true; }

    return newMessages.some((newMsg) => {
      const oldMsg = oldMessages.find(i => i.date === newMsg.date);
      return (
        newMsg.videoRemoteId !== oldMsg?.videoRemoteId ||
        newMsg.photoRemoteId !== oldMsg?.photoRemoteId ||
        newMsg.isRead !== oldMsg.isRead ||
        newMsg.editDate !== oldMsg.editDate ||
        newMsg.id !== oldMsg?.id
      );
    });
  }

  public setMessagesQueryParams(chatId: number): MessagesQueryParams {
    return {
      chatId: chatId,
      limit: 200,
      accountId: this.telegramAccountsService.selectedAccount().accountId
    };
  }
}
